import Vue from 'vue'
import Router from 'vue-router'

import Landing from './components/Landing.vue'

Vue.use(Router)

export default new Router(
  mode: 'history'
  base: process.env.BASE_URL
  routes: [
    {
      path: '/',
      name: 'Landing',
      component: Landing,
      children: [
        { path: '/mages' }
        { path: '/mages-soccer' }
        { path: '/archers' }
        { path: '/fat-hooks' }
        { path: '/shootout' }
      ]
    },
    # {
    #   path: '/lazy',
    #   component: -> `import(/* webpackChunkName: "about" */ './views/Lazy.vue')`
    # }
  ]
)
